const getters = {};

export default getters;



// WEBPACK FOOTER //
// ./src/store/modules/auth/getters.js